module.exports = __webpack_public_path__ + "static/media/warning.656e191f.png";